
  //  日程提醒方式枚举
  let remindOptions = [
    {value: "0", label: "无提醒"},
    {value: "1", label: "开始时"},
    {value: "2", label: "10 分钟前"},
    {value: "3", label: "30 分钟前"},
    {value: "4", label: "一小时前"},
    {value: "5", label: "一天前"},
    {value: "6", label: "一周前"}
  ];
  // 自定义重复方式单位列表
  let repeatDiyOptions = [
    {
      value: '1',
      label: "日"
    },
    {
      value: '2',
      label: "周"
    },
    {
      value: '3',
      label: "月"
    },
    {
      value: '4',
      label: "年"
    }
  ];
  // 日程提出重复枚举
  let repeatTypeOptions = [
    {value: "01", label: "不重复"},
    {value: "02", label: "每天"},
    {value: "03", label: "每周"},
    {value: "04", label: "每个工作日(周一至周五)"},
    {value: "05", label: "每个休息日(周六和周日)"},
    {value: "06", label: "自定义"}
  ]
  // remindOptions 日程提醒方式枚举;
  // repeatDiyOptions 自定义重复方式单位列表
  // repeatTypeOptions 日程提出重复枚举

  export { remindOptions, repeatDiyOptions, repeatTypeOptions }

